import { cloneDeep } from 'lodash'

export default class AbstractRequest {
	/**
	 * @constructor
	 */
	constructor() {
		if (new.target instanceof AbstractRequest) {
			throw new Error("Can't instanciate abstract class AbstractRequest")
		}

		this._params = {}
		this._orCount = 0
		this._sort = []
		this._fields = []
	}

	/**
	 * Set request limit
	 * @param {number} limit - Limit
	 * @return {object} - This
	 */
	limit(limit) {
		this._params.limit = limit
		return this
	}

	/**
	 * Set request offset
	 * @param {number} offset - Offset
	 * @return {object} - This
	 */
	offset(offset) {
		delete this._params.page
		this._params.skip = offset
		return this
	}

	/**
	 * Set request page
	 * @param {number} page - Page number
	 * @return {object} - This
	 */
	page(page) {
		delete this._params.skip
		this._params.page = page
		return this
	}

	/**
	 * Add request sort
	 * @param {string} sort - Sorting field
	 * @return {object} - This
	 */
	sort(sort) {
		this._sort.push(sort)
		this._params.sort = this._sort.join(',')
		return this
	}

	/**
	 * Add request fields projection
	 * @param {array} fields - Fields name
	 * @return {object} - This
	 */
	fields(fields) {
		this._fields = [...this._fields, ...fields]
		this._params.fields = this._fields.join(',')
		return this
	}

	/**
	 * Add request field projection
	 * @param {string} field - Field name
	 * @return {object} - This
	 */
	field(field) {
		return this.fields([field])
	}

	/**
	 * Add parameter
	 * @param {string} name - Parameter name
	 * @param {any} value - Parameter value
	 * @param {string} operator - Parameter operator
	 * @return {object} - This
	 */
	param(name, value, operator = null) {
		this._params[operator ? `${name}[${operator}]` : name] = value
		return this
	}

	/**
	 * Add OR parameter
	 * @param {string} name - Parameter name
	 * @param {any} value - Parameter value
	 * @param {string} operator - Parameter operator
	 * @param {number} group - Specific OR group
	 * @return {object} - This
	 */
	orParam(name, value, operator = null, group = -1) {
		this._params[`or[${group > -1 ? group : this._orCount++}][${name}]${operator ? `[${operator}]` : ''}`] = value
		if (group > -1 && group >= this._orCount) {
			this._orCount = group + 1
		}

		return this
	}

	/**
	 * Set parameters
	 * @param {object} params - Parameters
	 * @return {object} - This
	 */
	params(params) {
		this._params = cloneDeep(params)
		return this
	}

	/**
	 * Add request sorting and pagination from pagination data
	 * @param {object} pagination - Pagination type object
	 * @return {object} - This
	 */
	fromPagination({ page, limit, sort }) {
		this.limit(limit).page(page)
		if (sort) {
			this.sort(sort)
		}
		return this
	}
}
